import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Text,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React, { useContext } from 'react';
import { PortalContext } from '../../../context/PortalContext';
import { formatOwnership } from '../../../tracking/trackingHelper';
import { useTrackingManager } from '../../../tracking/useTrackingManager';

export const ClimaproSpecialCTA: React.FC<{
	ctaAnswers: { label: string; value: string; stepsToShow?: string[] }[];
	actualStep: number;
	totalSteps: number;
	handleLinealNextStep: (answer?: string[]) => void;
	stepName: string;
	userLevel: number;
}> = ({ ctaAnswers, actualStep, totalSteps, handleLinealNextStep, stepName, userLevel }) => {
	const { portalService } = useContext(PortalContext);

	const selectedValuesRef = React.useRef<string[]>([]);

	const trackingManager = useTrackingManager();
	const userVehicles = portalService.getPersonVehicles().getValue();

	const handleClick = (index: number, event: React.MouseEvent<HTMLButtonElement>) => {
		selectedValuesRef.current = [...selectedValuesRef.current, ctaAnswers[index].value];
		if (actualStep + 2 == totalSteps) {
			handleLinealNextStep(selectedValuesRef.current);
			selectedValuesRef.current = [];
		} else {
			handleLinealNextStep();
		}
		handleLinealNextStep();
		event.currentTarget.blur();

		trackingManager.trackClubVWFormButtonClick(
			{
				FormName: `Data Colection Form-${userLevel}`,
				FormStart: false,
				FormTypeMultiple: ['otherform'],
			},
			{ contentId: `Answered step: ${stepName}` },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
	};

	return (
		<Container
			padding={{
				top: {
					[Breakpoints.default]: ContainerPadding.static500,
					[Breakpoints.b960]: ContainerPadding.static520,
				},
			}}
			wrap={{ [Breakpoints.default]: 'always', [Breakpoints.b960]: 'never' }}
			gutter={{ [Breakpoints.default]: ContainerGutter.static350, [Breakpoints.b960]: ContainerGutter.static450 }}
			stretchContent
		>
			{ctaAnswers.map((cta, index) => (
				<CTA
					key={index}
					tag="button"
					emphasis={'secondary'}
					size={'large'}
					onClick={(event) => handleClick(index, event)}
					stretchContent
				>
					<Text appearance={TokenTextAppearance.bigcopy100} bold>
						{cta.label}
					</Text>
				</CTA>
			))}
		</Container>
	);
};
